/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useUser } from '@shortlyster/auth-layer';
import { FetchProfile } from './queries';
import { useAuth } from 'react-oidc-context';
import { useApolloClients } from './AuthorizedApolloProvider';

export const AuthFetcher: React.FC = ({ children }) => {
  const { signoutRedirect } = useAuth();
  const [authUser, setUser] = useUser();
  const { federationGatewayClient } = useApolloClients()!;
  const [ready, setReady] = useState(false);

  const { data, loading, error } = useQuery(FetchProfile, { client: federationGatewayClient });

  const signout = (errorMsg: string) => {
    window.alert(errorMsg);
    setUser(null);
    window.sessionStorage.clear();
    signoutRedirect({
      post_logout_redirect_uri: window.location.origin,
    });
  };

  useEffect(() => {
    if (
      error ||
      !data?.myProfile?.accesses?.genericApps?.some(app => app.appCode === 'compono-admin')
    ) {
      let errorMsg = error?.message || 'Unknown error';
      if (/.*(401|403|authorized).*/.test(errorMsg)) {
        errorMsg = 'You do not have permission';
        // TODO: Use a proper error page
        signout(errorMsg);
        return;
      }
    }
  }, [error, data]);

  useEffect(() => {
    if (loading) return;
    if (data?.myProfile && !error) {
      setUser(data.myProfile).then(() => setReady(true));
    } else if (authUser) {
      setUser(null).then(() => setReady(true));
    } else {
      setReady(true);
    }
  }, [loading, data]);

  return ready && !error ? <>{children}</> : null;
};
